{
  "shared": {
    "hole": "Hole",
    "charged": "Charged",
    "stemming": "Stemming",
    "depthM": "Depth (m)",
    "designM": "Design (m)",
    "waterM": "Water (m)",
    "initiation": "Initiation",
    "micKg": "Max instantaneous charge (kg)",
    "distanceFromBlast": "Distance from the blast (m)",
    "firing": "Firing",
    "firingNo": "Firing {{number}}",
    "record": "Record",
    "recordAnyway": "Record anyway",
    "recordItAnyway": "Record it anyway?",
    "saveChanges": "Save changes",
    "open": "Open",
    "clear": "Clear",
    "correct": "Correct",
    "remove": "Remove"
  },
  "patternStatus": {
    "designed": "Designed",
    "drilling": "Drilling",
    "drilled": "Drilled",
    "charging": "Charging",
    "charged": "Charged",
    "fired": "Fired",
    "closed": "Closed",
    "cancelled": "Cancelled"
  },
  "patternShape": {
    "square": "Square",
    "staggered": "Staggered"
  },
  "initiation": {
    "electronic": "Electronic",
    "nonElectric": "Non-electric",
    "electric": "Electric",
    "mixed": "Mixed"
  },
  "weather": {
    "clear": "Clear",
    "cloud": "Cloud",
    "rain": "Rain",
    "storm": "Storm",
    "fog": "Fog"
  },
  "treatment": {
    "refire": "Refired",
    "washOut": "Washed out",
    "supervisedDigOut": "Supervised dig-out",
    "other": "Other"
  },
  "fragmentationMethod": {
    "photo": "Photo analysis",
    "drone": "Drone survey",
    "shovelCamera": "Shovel camera",
    "visual": "Visual estimate"
  },
  "holeStatus": {
    "designed": "Designed",
    "drilled": "Drilled",
    "redrillRequired": "Redrill required",
    "backfillRequired": "Backfill required",
    "dipped": "Dipped",
    "charged": "Charged",
    "stemmed": "Stemmed",
    "fired": "Fired",
    "abandoned": "Abandoned",
    "misfire": "Misfire"
  },
  "drillOutcome": {
    "complete": "Complete",
    "short": "Short",
    "collapsed": "Collapsed",
    "blocked": "Blocked",
    "abandoned": "Abandoned"
  },
  "dipCondition": {
    "dry": "Dry",
    "wet": "Wet",
    "dewatered": "Dewatered",
    "collapsed": "Collapsed",
    "blocked": "Blocked",
    "cavity": "Cavity"
  },
  "dipAction": {
    "none": "None",
    "backfill": "Backfill",
    "cleanOut": "Clean out",
    "redrill": "Redrill",
    "abandon": "Abandon"
  },
  "designField": {
    "holeName": "Hole name",
    "holeType": "Hole type",
    "collarE": "Collar easting",
    "collarN": "Collar northing",
    "collarRl": "Collar RL",
    "toeE": "Toe easting",
    "toeN": "Toe northing",
    "toeRl": "Toe RL",
    "dip": "Dip",
    "azimuth": "Azimuth",
    "length": "Length",
    "diameter": "Diameter",
    "delayMs": "Delay (ms)",
    "stemmingM": "Stemming (m)"
  },
  "metric": {
    "ppv": "PPV",
    "airblast": "Airblast"
  },
  "complianceWindow": {
    "lastN_one": "last {{count}} blast",
    "lastN_other": "last {{count}} blasts",
    "lastUnknown": "last ? blasts",
    "calendarYear": "calendar year"
  },
  "tabs": {
    "design": "Design",
    "holes": "Holes",
    "drilling": "Drilling",
    "dipping": "Dipping",
    "charging": "Charging",
    "explosives": "Explosives",
    "firing": "Firing",
    "monitoring": "Monitoring",
    "fragmentation": "Fragmentation",
    "digging": "Digging"
  },
  "page": {
    "crumb": "Blast Patterns",
    "loadFailed": "This blast pattern could not be loaded. It may be in a pit outside your zones.",
    "blastRecord": "Blast record",
    "blastRecordTitle": "Blast record {{reference}}",
    "nowStatus": "{{reference}} is now {{status}}",
    "markFired": "Mark as fired",
    "markFiredBody": "The date the pattern was fired. Geology and the production reports read it as the blast date.",
    "cancelTitle": "Cancel {{reference}}",
    "cancelBody": "A cancelled pattern drops out of the pattern lists. It can be reopened later.",
    "cancelPattern": "Cancel pattern",
    "firedOn": "Fired on",
    "goAheadAnyway": "Go ahead anyway?",
    "back": "Back",
    "openMisfires_one": "{{count}} open misfire on this pattern.",
    "openMisfires_other": "{{count}} open misfires on this pattern.",
    "charged": "Charged"
  },
  "summary": {
    "rl": "RL {{value}}",
    "holes_one": "{{count}} hole",
    "holes_other": "{{count}} holes",
    "burdenSpacing": "{{burden}} x {{spacing}} m",
    "burdenSpacingShape": "{{burden}} x {{spacing}} m {{shape}}",
    "bcm": "{{value}} bcm"
  },
  "kpi": {
    "holesDrilled": "Holes drilled",
    "ofDesigned_one": "of {{count}} designed",
    "ofDesigned_other": "of {{count}} designed",
    "metresDrilled": "Metres drilled",
    "ofMetresDesigned": "of {{value}} m designed",
    "redrill": "Redrill",
    "drillingShifts_one": "{{count}} shift, {{from}} to {{to}}",
    "drillingShifts_other": "{{count}} shifts, {{from}} to {{to}}",
    "noDrilling": "No drilling recorded",
    "fired": "Fired",
    "notYet": "Not yet",
    "closedOn": "Closed {{date}}"
  },
  "design": {
    "saved": "Design saved",
    "benchAndRock": "Bench and rock",
    "benchRl": "Bench RL (m)",
    "benchHeight": "Bench height (m)",
    "freeFaces": "Free faces",
    "rockDensity": "Rock density (t/m³)",
    "geometry": "Geometry",
    "burden": "Burden (m)",
    "spacing": "Spacing (m)",
    "subdrill": "Subdrill (m)",
    "shape": "Shape",
    "bitSize": "Bit size",
    "designHoles": "Design holes",
    "designMetres": "Design metres",
    "stemmingAndExplosives": "Stemming and explosives",
    "stemming": "Stemming (m)",
    "stemmingMaterial": "Stemming material",
    "designExplosives": "Design explosives (kg)",
    "powderFactorVolume": "Powder factor (kg/m³)",
    "plannedFiring": "Planned firing",
    "designVolume": "Design volume",
    "designVolumeNote": "Burden x spacing x height x holes",
    "powderFactor": "Powder factor",
    "fromExplosivesAndVolume": "From explosives and volume",
    "powderFactorByMass": "Powder factor by mass",
    "saveDesign": "Save design",
    "schematic": "Schematic"
  },
  "schematic": {
    "planAria_one": "Plan of {{count}} hole in {{rows}} row",
    "planAria_other": "Plan of {{count}} holes in {{rows}} rows",
    "freeFace": "Free face",
    "spacing": "Spacing {{value}}",
    "burden": "Burden {{value}}",
    "sectionAria": "Section through one hole",
    "bit": "Bit {{bit}}",
    "bench": "Bench {{value}}",
    "stemming": "Stemming {{value}}",
    "charge": "Charge {{value}}",
    "subdrill": "Subdrill {{value}}",
    "hole": "Hole {{value}}",
    "enterPlan": "Enter the burden, spacing and design holes to draw the plan.",
    "enterSection": "Enter the bench height to draw a hole.",
    "note_one": "A schematic from the design figures, {{count}} row of up to {{perRow}}, front row nearest the free face.",
    "note_other": "A schematic from the design figures, {{count}} rows of up to {{perRow}}, front row nearest the free face.",
    "notSurveyed": "It is not the surveyed hole positions, which a design import or BlastLogic provides."
  },
  "holes": {
    "addHole": "Add a hole",
    "addHoleIntro": "For a hole drilled that the design does not have. It starts with no design figures.",
    "holeName": "Hole name",
    "holeType": "Hole type",
    "spotAt": "It goes at E {{e}}, N {{n}}. Tap again to move it.",
    "tapToPlace": "Tap the plan where it was drilled to put it on the plan; without a spot it is in the table only.",
    "clearSpot": "Clear the spot",
    "designDepth": "Design depth",
    "drilled": "Drilled",
    "attempts_one": "{{count}} attempt",
    "attempts_other": "{{count}} attempts",
    "dipped": "Dipped",
    "water": "Water",
    "decks_one": "{{count}} deck",
    "decks_other": "{{count}} decks",
    "designStemming": "design {{value}}",
    "drilledM": "Drilled (m)",
    "dippedM": "Dipped (m)",
    "chargedKg": "Charged (kg)",
    "finalNote": "The pattern is {{status}}, so its holes are final",
    "drillPlan": "Drill plan for the rig",
    "importDesign": "Import the design",
    "noHoles": "This pattern has no holes yet. Import its design from the design package's CSV.",
    "tapToSee": "Tap a hole on the plan to see it.",
    "unplaced_one": "{{count}} hole has no position and is in the table only.",
    "unplaced_other": "{{count}} holes have no position and are in the table only."
  },
  "designImport": {
    "imported": "Design imported",
    "summary": "{{items}}.",
    "added_one": "{{count}} added",
    "added_other": "{{count}} added",
    "updated_one": "{{count}} updated",
    "updated_other": "{{count}} updated",
    "removed_one": "{{count}} removed",
    "removed_other": "{{count}} removed",
    "kept_one": "{{count}} kept for their history",
    "kept_other": "{{count}} kept for their history",
    "done": "Done",
    "intro": "A CSV from SHOTPlus, BlastLogic, Deswik, Datamine, Surpac or similar, one row per hole. Holes already here are updated by name.",
    "dropLabel": "Drag & drop the design CSV here, or click to browse",
    "rows_one": "{{count}} row in {{file}}.",
    "rows_other": "{{count}} rows in {{file}}.",
    "readAsLastTime": "Columns read as last time for {{name}}.",
    "useSaved": "Use a saved mapping",
    "diameterIn": "Diameter in",
    "dipFromVertical": "Dip measured from vertical",
    "saveMappingAs": "Save the mapping as",
    "import": "Import"
  },
  "dipping": {
    "lastDip": "Last dip {{when}}",
    "waterNote": "{{value}} m water",
    "dippedSnack": "{{hole}} dipped",
    "condition": "Condition",
    "action": "Action",
    "backfilled": "Backfilled (m)",
    "dippedBy": "Dipped by",
    "dipped": "Dipped",
    "by": "By",
    "noBackfillNote": "With no metres backfilled the hole shows backfill required until it is dipped again.",
    "noHoles": "This pattern has no holes yet. Import its design on the Holes tab to dip it hole by hole.",
    "summary_one": "{{done}} of {{count}} hole dipped",
    "summary_other": "{{done}} of {{count}} holes dipped",
    "attention_one": "{{count}} needs a redrill, clean out or backfill",
    "attention_other": "{{count}} need a redrill, clean out or backfill",
    "everyHoleDone": "Every hole is dipped",
    "changing": "Changing the dip taken {{when}}.",
    "tapHole": "Tap a hole on the plan, or take the next hole, to dip it."
  },
  "charging": {
    "deck": "Deck",
    "product": "Product",
    "removeLine": "Remove the line",
    "design": "Design",
    "designWithUnit": "Design ({{unit}})",
    "actual": "Actual",
    "actualWithUnit": "Actual ({{unit}})",
    "from": "From (m)",
    "to": "To (m)",
    "chargedSnack": "{{hole}} charged",
    "clearedSnack": "{{hole}}'s charge cleared",
    "noLines": "No lines. Saving clears the hole's charge.",
    "addLine": "Add a line",
    "sameAsLast": "Same as the last hole",
    "actualAsDesigned": "Actual as designed",
    "clearCharge": "Clear the charge",
    "explosiveKg": "Explosive (kg)",
    "chargeM": "Charge (m)",
    "stemmingM": "Stemming (m)",
    "flags": "Flags",
    "noHoles": "This pattern has no holes yet. Import its design on the Holes tab to charge it hole by hole.",
    "summary_one": "{{charged}} of {{count}} hole charged, {{stemmed}} stemmed · {{kg}} kg in",
    "summary_other": "{{charged}} of {{count}} holes charged, {{stemmed}} stemmed · {{kg}} kg in",
    "flagged_one": "{{count}} flagged",
    "flagged_other": "{{count}} flagged",
    "everyHoleDone": "Every hole is charged",
    "tapHole": "Tap a hole on the plan, or take the next hole, to charge it."
  },
  "progress": {
    "toDrill": "To drill",
    "drilled": "Drilled",
    "dipped": "Dipped",
    "charged": "Charged",
    "stemmed": "Stemmed",
    "fired": "Fired",
    "metresToDrill": "{{value}} m to drill",
    "holesToDip": "{{holes}} to dip",
    "holesToCharge": "{{holes}} to charge",
    "holesToStem": "{{holes}} to stem",
    "inPlay_one": "{{count}} hole in play",
    "inPlay_other": "{{count}} holes in play",
    "nothingLeft": "Nothing left to do before firing",
    "openSheets": "Open sheets: {{sheets}}"
  },
  "workSheets": {
    "drill": {
      "heading": "Drill sheets",
      "issue": "Issue a drill sheet",
      "tapHoles": "Tap holes to add them or take them off. A hole on another open drill sheet is faded and cannot be added.",
      "allStillTo": "All still to drill",
      "noneOpen": "No drill sheet is open. Issue one to send a crew a set of holes, printed or on a tablet.",
      "closeConfirm": "{{done}} of {{total}} holes are done. Closing the sheet frees its holes for another drill sheet."
    },
    "dip": {
      "heading": "Dip sheets",
      "issue": "Issue a dip sheet",
      "tapHoles": "Tap holes to add them or take them off. A hole on another open dip sheet is faded and cannot be added.",
      "allStillTo": "All still to dip",
      "noneOpen": "No dip sheet is open. Issue one to send a crew a set of holes, printed or on a tablet.",
      "closeConfirm": "{{done}} of {{total}} holes are done. Closing the sheet frees its holes for another dip sheet."
    },
    "charge": {
      "heading": "Charge sheets",
      "issue": "Issue a charge sheet",
      "tapHoles": "Tap holes to add them or take them off. A hole on another open charge sheet is faded and cannot be added.",
      "allStillTo": "All still to charge",
      "noneOpen": "No charge sheet is open. Issue one to send a crew a set of holes, printed or on a tablet.",
      "closeConfirm": "{{done}} of {{total}} holes are done. Closing the sheet frees its holes for another charge sheet."
    },
    "issuedSnack": "{{name}} issued",
    "nameBlankFor": "Name (blank for {{name}})",
    "issuedTo": "Issued to",
    "holes_one": "{{count}} hole",
    "holes_other": "{{count}} holes",
    "none": "None",
    "issue": "Issue",
    "issuedAt": "Issued {{when}}",
    "doneOf": "{{done}} of {{total}} done",
    "showEvery": "Show every hole",
    "workThis": "Work this sheet",
    "print": "Print",
    "closeTitle": "Close {{name}}",
    "workingNote": "Working {{name}}: {{done}} of {{total}} done"
  },
  "firing": {
    "checks": {
      "finalNeedsTime": "The final firing needs the time it was fired.",
      "alreadyFinal": "This blast already has a final firing.",
      "future": "A firing cannot be recorded in the future.",
      "fumeRange": "Fume ratings run from 0 to 5.",
      "nameShotfirer": "Name the shotfirer.",
      "exclusionZone": "Record the exclusion zone.",
      "mic": "Record the maximum instantaneous charge.",
      "nearestStructure": "Record the distance to the nearest structure.",
      "weather": "Record the weather.",
      "circuitTest": "Record the circuit test.",
      "sentryCount": "Record how many sentries were posted.",
      "noLicence": "The shotfirer holds no current shotfirer or blast controller licence."
    },
    "queued": "No connection, so the firing is saved on this device. It reaches the blast record when the connection is back.",
    "savedFinal": "Firing saved; the blast is marked fired",
    "saved": "Firing saved",
    "recordFiring": "Record a firing",
    "timeAndPeople": "Time and people",
    "planned": "Planned",
    "fired": "Fired",
    "shotfirer": "Shotfirer",
    "allClearBy": "All clear given by",
    "finalFiring": "Final firing of this blast",
    "initiationAndQuantities": "Initiation and quantities",
    "circuitTestPassedQuestion": "Circuit test passed",
    "holesFired": "Holes fired",
    "totalExplosive": "Total explosive (kg)",
    "delayWindow": "Delay window (ms)",
    "circuitTestNotes": "Circuit test notes",
    "safety": "Safety",
    "exclusionZoneM": "Exclusion zone (m)",
    "sentriesPosted": "Sentries posted",
    "nearestStructureM": "Nearest structure (m)",
    "bearingToIt": "Bearing to it (°)",
    "allClear": "All clear",
    "weather": "Weather",
    "conditions": "Conditions",
    "temperature": "Temperature (°C)",
    "windFrom": "Wind from (°)",
    "windSpeed": "Wind speed (km/h)",
    "outcome": "Outcome",
    "misfireReportedCheck": "Misfire reported",
    "flyrockObserved": "Flyrock observed",
    "flyrockReached": "Flyrock reached (m)",
    "fumeRatingRange": "Fume rating (0-5)",
    "saveItAnyway": "Save it anyway?",
    "saveAnyway": "Save anyway",
    "misfireQueued": "No connection, so the misfire is saved on this device. It is the first thing sent when the connection is back.",
    "misfireClearedSnack": "Misfire cleared",
    "misfireReportedSnack": "Misfire reported",
    "clearMisfire": "Clear the misfire",
    "reportMisfire": "Report a misfire",
    "cleared": "Cleared",
    "found": "Found",
    "clearedBy": "Cleared by",
    "foundBy": "Found by",
    "treatment": "Treatment",
    "suspectedCause": "Suspected cause",
    "report": "Report",
    "firings": "Firings",
    "noFiring": "No firing recorded. The blast is marked fired when its final firing is saved.",
    "final": "Final",
    "savedOnDevice": "Saved on this device",
    "plannedFired": "Planned / fired",
    "circuitNotRecorded": "Circuit test not recorded",
    "circuitPassed": "Circuit test passed",
    "circuitFailed": "Circuit test failed",
    "exclusionZone": "Exclusion zone",
    "sentries_one": "{{count}} sentry",
    "sentries_other": "{{count}} sentries",
    "mic": "Max instantaneous charge",
    "perDelay": "per {{ms}} ms",
    "scaledDistanceNearest": "Scaled distance, nearest structure",
    "windNote": "{{speed}} km/h from {{direction}}°",
    "flyrockTo": "Flyrock to {{distance}} m",
    "noFlyrock": "No flyrock",
    "fumeRating": "Fume rating {{rating}}",
    "misfires": "Misfires",
    "noMisfires": "No misfires.",
    "status": {
      "open": "Open",
      "cleared": "Cleared"
    },
    "holeReference": "Hole {{reference}}",
    "holeNotIdentified": "Hole not identified",
    "foundOn": "found {{when}}",
    "foundOnBy": "found {{when}} by {{person}}",
    "clearedOn": "{{treatment}} {{when}}",
    "clearedLower": "cleared"
  },
  "sentries": {
    "saved": "Sentry saved",
    "editTitle": "Edit the sentry",
    "postTitle": "Post a sentry for firing {{number}}",
    "sentry": "Sentry",
    "post": "Post",
    "bearingFrom": "Bearing from the blast (°)",
    "orLatitude": "Or latitude",
    "andLongitude": "And longitude",
    "measuredFrom": "Measured from the centre of the pattern's outline on the map.",
    "measuredFromWithZone": "Measured from the centre of the pattern's outline on the map; the exclusion zone is {{distance}} m.",
    "noOutline": "A pattern with no outline takes a latitude and longitude instead.",
    "distanceAt": "{{distance}} m at {{bearing}}°",
    "noPosition": "No position",
    "clearanceTitle": "Clearance sheet, firing {{number}}",
    "heading": "Sentries",
    "postSentry": "Post a sentry",
    "clearanceSheet": "Clearance sheet",
    "none": "No sentries posted yet. Each one goes on the clearance sheet and, on the day, on the map.",
    "removeTitle": "Remove the sentry",
    "removeConfirm": "Take {{name}} off the clearance plan?",
    "thisSentry": "this sentry"
  },
  "monitoring": {
    "saved": "Reading saved",
    "correctTitle": "Correct the reading",
    "addReading": "Add a reading",
    "firingAt": "Firing {{number}}, {{when}}",
    "monitor": "Monitor",
    "recorded": "Recorded",
    "ppvMmS": "PPV (mm/s)",
    "frequencyHz": "Frequency (Hz)",
    "airblastDbl": "Airblast (dB(L))",
    "triggered": "The monitor triggered",
    "notes": "Notes",
    "calibrationOverdue": "{{monitor}} was due for calibration on {{date}}. The reading is kept and flagged.",
    "standingLabel": "{{metric}}, {{window}}",
    "overOf": "{{over}} of {{blasts}}",
    "blastsOver_one": "blast over {{limit}} {{unit}}",
    "blastsOver_other": "blasts over {{limit}} {{unit}}",
    "standingNote": "{{exceedance}}% against {{allowed}}% allowed, as of {{asOf}}",
    "standingNoteWithMaximum": "{{exceedance}}% against {{allowed}}% allowed; {{overMaximum}} over {{maximum}} {{unit}}, as of {{asOf}}",
    "none": "none",
    "valueOfLimit": "{{value}} {{unit}} of {{limit}}",
    "distance": "Distance",
    "frequency": "Frequency",
    "scaledDistance": "Scaled distance",
    "overMaximum": "Over the maximum",
    "withinLimit": "Within limit",
    "overLimit": "Over the limit",
    "calibrationDue": "Calibration due {{date}}",
    "fromSystem": "From {{system}}",
    "fromMonitor": "From the monitor",
    "notTriggered": "Not triggered",
    "notFired": "Readings are added once the blast has been fired.",
    "readings": "Readings"
  },
  "fragmentation": {
    "saved": "Survey saved",
    "correctTitle": "Correct the survey",
    "addTitle": "Add a fragmentation survey",
    "surveyedOn": "Surveyed on",
    "method": "Method",
    "p50Mm": "P50 (mm)",
    "p80Mm": "P80 (mm)",
    "p90Mm": "P90 (mm)",
    "topSizeMm": "Top size (mm)",
    "oversizePercent": "Oversize (%)",
    "oversizeThreshold": "Oversize is above (mm)",
    "explain": "P50, P80 and P90 are the sizes half, 80% and 90% of the muckpile passes. Leave out what the survey did not give.",
    "surveyed": "Surveyed",
    "topSize": "Top size",
    "oversize": "Oversize",
    "oversizeAbove": "{{percent}}% above {{size}}",
    "removeTitle": "Remove the survey",
    "removeConfirm": "Remove the {{method}} of {{date}}?",
    "notFired": "Fragmentation is surveyed once the blast has been fired.",
    "heading": "Fragmentation surveys",
    "addSurvey": "Add a survey"
  },
  "reconciliation": {
    "signedOffSnack": "Variance signed off",
    "signOffTitle": "Sign off {{material}}",
    "unaccounted": "{{amount}} {{unit}} issued to this blast were neither charged nor returned.",
    "permanent": "The sign-off is permanent and appears on the blast record.",
    "reason": "Reason (required)",
    "signOff": "Sign off",
    "product": "Product",
    "issued": "Issued",
    "returned": "Returned",
    "destroyed": "Destroyed",
    "variance": "Variance",
    "signedOffBy": "Signed off by {{person}}",
    "needsSignOff": "Needs sign-off",
    "balanced": "Balanced",
    "withinTolerance": "Within tolerance",
    "heading": "Reconciliation",
    "magazineSlip": "Magazine slip",
    "printSlip": "Print the magazine slip",
    "explain": "Issued, less returned, destroyed on the bench and charged, gives the variance for each product. Counted items must balance exactly and bulk product within the mine's tolerance.",
    "explainSignOff": "A variance needs an admin's sign-off before the blast can close."
  },
  "digging": {
    "excavator": "Excavator",
    "shifts": "Shifts",
    "lastDug": "Last dug",
    "day": "Day",
    "noneYet": "No excavator has dug this blast yet. Digging shows here once a loading is recorded against it.",
    "openMisfires_one": "An open misfire on this blast: warn every excavator digging it.",
    "openMisfires_other": "{{count}} open misfires on this blast: warn every excavator digging it.",
    "broken": "Broken",
    "notRecorded": "Not recorded",
    "byDesign": "By the blast's design",
    "dug": "Dug",
    "dugShare": "{{share}}% of it, {{from}} to {{to}}",
    "dugRange": "{{from}} to {{to}}",
    "brokenStockLeft": "Broken stock left",
    "unknown": "Unknown",
    "tonnesNotRecorded": "The blast's tonnes were not recorded",
    "excavators": "Excavators",
    "byShift": "By shift"
  },
  "firingPatterns": {
    "crumb": "Firing",
    "panelTitle": "Charging, charged, fired in the last two days, or with an open misfire",
    "pattern": "Pattern",
    "pitStage": "Pit / stage",
    "openMisfires_one": "{{count}} open misfire",
    "openMisfires_other": "{{count}} open misfires",
    "fired": "Fired"
  }
}
